import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { getPastUpdate } from '@debbie/common/dist/workflows/index.js';
import { c } from '@debbie/cortex/dist/index.js';
import { selectUpdateTypeGroups } from '@debbie/cortex/dist/update-type-groups/selectors.js';
import THEME from '../theme.js';
const WorkflowStages = (props) => {
    const { workflow, updates, case: singleCase } = props;
    const updateTypeGroups = useSelector(selectUpdateTypeGroups);
    useEffect(() => {
        if (!updateTypeGroups) {
            c.updateTypeGroups.get();
        }
    }, []);
    if (!workflow.stages || !updateTypeGroups)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(UpdateTypeGroups, null, workflow.stages.map((stage) => {
            const group = updateTypeGroups &&
                updateTypeGroups.find((group) => group.groupId === stage.groupId);
            if (!group)
                return null;
            const active = !!updates.find((update) => update.taskId && stage.taskIdMap[update.taskId]);
            const currentUpdate = getPastUpdate(updates, workflow.workflowId);
            const current = currentUpdate?.updateTypeGroupId === stage.groupId;
            return (React.createElement(UpdateTypeGroup, { current: current, active: active, "data-tooltip-content": group.label, "data-tooltip-id": "tooltip-default", key: group.groupId }, group.short));
        }))));
};
export default WorkflowStages;
const UpdateTypeGroups = styled.div `
  display: inline-block;
  margin-left: 9px;
  font-size: 0.8em;
  font-weight: 600;
  vertical-align: middle;
`;
const UpdateTypeGroup = styled.div `
  display: inline-block;
  position: relative;
  padding: 2px 4px;
  ${(props) => props.active
    ? `border: 1px solid ${THEME.COLOR_ACCENT}`
    : 'border: 1px solid lightgrey'};

  margin-left: -1px;

  &&:last-child {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  &&:first-child {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }

  ${(props) => (props.current ? 'padding-right: 11px;' : '')}
  ${(props) => props.current
    ? `
  &:after {
    content: "";
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${THEME.COLOR_ACCENT};
    display: inline-block;
    position: absolute;
    top: 4px;
    right: 3px;
  }
  `
    : ''};
`;
//# sourceMappingURL=WorkflowStages.js.map